import ReleaseOrderNote from './ReleaseOrderNote.component';

export default ReleaseOrderNote;
